import React from 'react';
import Slide from 'react-reveal/Slide';
import CareerItem from './CareerItem';
import DownArrowIcon from '../../assets/down-arrow3.svg';
import { education, experience } from './data';
import styles from './styles.module.scss';

function Career() {
	return (
		<Slide bottom>
			<div className={`box ${styles.careerBox}`} id='careerBox'>
				<h1 className='section-title mobileHidden'>Education & Experience</h1>

				<div className={styles.careerContainer}>
					<div>
						<h1 className='section-title mobileShow'>Education </h1>

						{/* education */}
						<div>
							{education.map((item) => (
								<CareerItem
									type={item.type}
									title={item.title}
									info={item.info}
									date={item.date}
								/>
							))}
						</div>
					</div>

					<div>
						<h1 className='section-title mobileShow'>Experience</h1>

						{/* career */}
						<div>
							{experience.map((item) => (
								<CareerItem
									type={item.type}
									title={item.title}
									date={item.date}
								/>
							))}
						</div>
					</div>
				</div>

				<a href='#projectBox' className='downArrow'>
					<img src={DownArrowIcon} alt='arrow'></img>
				</a>
			</div>
		</Slide>
	);
}

export default Career;
